import PropTypes from 'prop-types';
import PreCall from '../vonage/device_settings/PreCall';
import localeMessage from './localeMessage';

const ClientVonagePreCall = ({
  appointment,
  user,
  locale,
  onComplete,
  onCancel,
}) => (
  <PreCall
    appointment={appointment}
    user={user}
    t={(id, values) => localeMessage(id, locale, values)}
    onComplete={onComplete}
    onCancel={onCancel}
    audience="client"
    footerVariant="client"
  />
);

ClientVonagePreCall.propTypes = {
  appointment: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ClientVonagePreCall;
